import React from 'react'
import Text from '../text/Text'

interface IProps {
    className?: string
    title?: string
    children?: any
    containerClassName?: string
}

const ContainerLayout: React.FC<IProps> = ({className, title, children, containerClassName}) => {
    return (
        <div className={`p-[20px] bg-white rounded-[10px] shadow-normal space-y-[40px] ${className}`}>
            {title && <Text className={'text-ti1'}>{title}</Text>}
            <div className={`${containerClassName}`}>{children}</div>
        </div>
    )
}

export default ContainerLayout
